export function RequiredIndicator() {
  return <span className="text-red-500">*</span>;
}
